/* import __COLOCATED_TEMPLATE__ from './close-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroActionComponentArgs } from 'embercom/lib/inbox2/bulk-action-types';

interface Signature {
  Element: HTMLDivElement;
  Args: MacroActionComponentArgs;
}

const CloseConversation = templateOnlyComponent<Signature>();
export default CloseConversation;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::MacroActions::CloseConversation': typeof CloseConversation;
    'inbox2/composer/macro-actions/close-conversation': typeof CloseConversation;
  }
}
